<div mat-dialog-content class="popup-container">
  <div class="popup-content">
    <div class="aviso">
      <button type="button" class="close-button" aria-label="Close" (click)="cerrarModal()">
        <img src="Inmuebles/assets/iconos/close-button.svg" alt="Cerrar">
      </button>
      <img src="Inmuebles/assets/iconos/Aviso.png" alt="Imagen del pop-up" class="popup-image" />
      <p class="bold-text">Aviso importante</p>
    </div>
    <p class="normal-text">Te informamos que las propiedades publicadas no corresponden a remates bancarios. Son ventas de inmuebles y cesiones de derechos.</p>
    <button class="btn" (click)="cerrarModal()">Aceptar</button>
  </div>
</div>